import { render } from "./LockScreen.vue?vue&type=template&id=3f2f7b72"
import script from "./LockScreen.vue?vue&type=script&lang=js"
export * from "./LockScreen.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__